// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.add-image[data-v-96cc7a2c] {\n  background-color: #acacac !important;\n}", ""]);
// Exports
module.exports = exports;
